import React, { useEffect, useMemo } from "react";

import Form from "devextreme-react/form";
import { ScrollView } from "devextreme-react/scroll-view";
import {
  createHtmlPortalNode,
  InPortal,
  OutPortal,
} from "react-reverse-portal";

import { Case, CaseElse, Switch, useWindowDimensions } from "@app/contexts";
import {
  contractorInEditMode,
  contractorInSpvMode,
  ECChooserPage,
  EMenuCmdTab,
  SPV_CONTRACTOR_MIRROR,
} from "@app/state/constants";
import { useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";
import { selectCurrentMirroredTab } from "@app/statefx/selectors/uiSpvMainContractor.sel";
import { TContractorFormSource } from "@app/types/insider";

import "../invoiceSPV/invoices.scss";
import { ContractorForm } from "./contractorForm";

import type { FormRef } from "devextreme-react/form";

export const ContractorEditingGroup = () => {
  const mainFormRef = React.useRef<FormRef>(null);
  const mirroredFormAnaf = React.useRef<FormRef>(null);
  const mirroredFormTemp = React.useRef<FormRef>(null);
  const mirrorForm = useFxSelector(selectCurrentMirroredTab);
  const headerTabs = useFxSelector(schema.uiJGBrowserHeader.select);
  const { height: fullHeight, headersFooters } = useWindowDimensions();
  const ContractorTMPPortal = useMemo(() => createHtmlPortalNode(), []);
  const ContractorANAFPortal = useMemo(() => createHtmlPortalNode(), []);

  const callerName = useMemo(() => {
    return headerTabs.tabSelected === EMenuCmdTab.CMD_BGIM_CLIENTS
      ? contractorInEditMode
      : contractorInSpvMode;
  }, [headerTabs.tabSelected]);

  return (
    <React.Fragment>
      <InPortal node={ContractorTMPPortal}>
        <ContractorForm
          key={"b"}
          source={"CFF_TMP"}
          frmConRef={mirroredFormTemp}
          mainConRef={mainFormRef}
          caller={callerName} //ie
        />
      </InPortal>
      <InPortal node={ContractorANAFPortal}>
        <ContractorForm
          key={"c"}
          source={"ANAF"}
          frmConRef={mirroredFormAnaf}
          mainConRef={mainFormRef}
          caller={callerName} //ie
        />
      </InPortal>
      <ScrollView height={fullHeight - (headersFooters + 60)}>
        <div id="contractor-in-mirror">
          <div className="contractor-cff">
            <ContractorForm
              key={"a"}
              source="CFF_MAIN"
              frmConRef={mainFormRef}
              caller={callerName} // ie
            />
          </div>
          <Switch value={mirrorForm}>
            <Case when={SPV_CONTRACTOR_MIRROR.CTR_MIRR_ANAF}>
              <div className="contractor-tmp">
                <OutPortal node={ContractorANAFPortal} />
              </div>
            </Case>
            <Case when={SPV_CONTRACTOR_MIRROR.CTR_MIRR_TMP}>
              <div className="contractor-tmp">
                <OutPortal node={ContractorTMPPortal} />
              </div>
            </Case>
          </Switch>
        </div>
      </ScrollView>
    </React.Fragment>
  );
};
